import Login from './Login.vue';

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login/index.js